<template>
    <div>
        <input
            ref="hidden-input"
            class="d-none"
            type="file"
            :name="name"
            :multiple="isMultiple"
            :accept="accept"
            autocomplete="off"
            @change="inputFileChanged"
        >

        <div class="input-group">
            <input
                class="form-control"
                type="text"
                v-model="fileNames"
                readonly
                @click="triggerInputClick"
            >

            <span class="input-group-append">
                <button
                    class="btn btn-light"
                    type="button"
                    @click="triggerInputClick"
                >
                    <slot>Bläddra...</slot>
                </button>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LimitlessFileInput',
    props: ['name', 'multiple', 'value', 'accept'],
    data: () => ({
        fileNames: '',
    }),
    computed: {
        isMultiple() {
            return typeof this.multiple !== 'undefined';
        },
    },
    methods: {
        triggerInputClick() {
            this.$refs['hidden-input'].click();
        },
        inputFileChanged(event) {
            this.$emit('change', event.target.files);
            this.updateText(event);
        },
        updateText(event) {
            let fileNames = '';
            const selectedFiles = event.target.files;

            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < selectedFiles.length; i++) {
                fileNames += selectedFiles[i].name + ', ';
            }

            fileNames = fileNames.replace(/,\s*$/, '');

            this.fileNames = fileNames;
        },
        clear() {
            this.$refs['hidden-input'].value = '';
            this.fileNames = '';
        },
    },
};
</script>
